import { Container, Link, OldText } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  onClick: () => void
}

const EmptyState: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('other')
  return (
    <Container py="2rem">
      <OldText variant="large">{t('noStoresFound')}.</OldText>
      <Link as="button" variant="brown" onClick={onClick} display="block">
        Reset filters
      </Link>
    </Container>
  )
}

export default EmptyState
